<template>
  <div class="reportDialog">
    <div class="btn" v-if="$route.query.report == 1" @click="open">
      📊 {{ $t("ConsultationReport") }}
    </div>
    <div class="main-dialog" v-show="showDialog">
      <div class="home">
        <div class="top-box">
          <p>
            <span> 📊 {{ $t("Personalized") }}</span>
          </p>
          <a-icon @click="close" class="icon" type="close-circle" />
        </div>
        <div class="main-box">
          <iframe
            id="myframe"
            class="frame"
            :style="{ height: maxWindowHeight + 'px' }"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from "@/utils/util";

export default {
  name: "reportDialog",
  data() {
    return {
      showDialog: false,
      maxWindowHeight: 700,
    };
  },
  i18n: require("./i18n"),
  methods: {
    close() {
      this.showDialog = false;
    },
    resizeWindow2() {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;

      let dialogHeight = h - 68;

      this.maxWindowHeight = dialogHeight;
    },
    open() {
      this.showDialog = true;
    },
  },
  mounted() {
    let str = localStorage.getItem("htmlCont");
    var iframe = document.getElementById("myframe");
    var doc = iframe.contentWindow.document;
    if (iframe.contentDocument) {
      doc = iframe.contentDocument;
    }
    doc.open();
    if (str && this.$route.query.report) {
      doc.write(
        `${str
          .replace("max-width: 960px;", "")
          .replace("margin: 30px auto;", "")
          .replace("<REPORT_START>", "")
          .replace("<REPORT_END>", "")
          .replace("margin: 15px;", "")
          .replaceAll("<br>", "")}`
      );
      doc.close();
      this.resizeWindow2();
      window.addEventListener(
        "resize",
        debounce(this.resizeWindow2, 300),
        false
      );
    }
  },
};
</script>
<style lang="less" scoped>
.btn {
  position: fixed;
  bottom: 80px;
  right: 30px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 100px 0px 1px 100px;
  background-color: rgba(239, 239, 239, 1);
  cursor: pointer;
  z-index: 999;
}
.main-dialog {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-flow: row-reverse;
  .home {
    width: 600px;
    height: 100%;
    background: #fff;
  }
  .top-box {
    .icon {
      font-size: 20px;
      color: #fff;
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 20px;
    }
    height: 68px;
    position: relative;
    background: linear-gradient(
      180.13deg,
      rgba(16, 117, 106, 0.74) 10.79%,
      rgba(16, 117, 117, 0) 99.89%
    );
    color: rgba(16, 16, 16, 1);
    font-size: 14px;

    p {
      padding-left: 30px;
      padding-top: 20px;
      font-weight: bold;
      font-size: 18px;
      text-align: left;
      color: rgba(16, 16, 16, 0.81);
    }
  }
  .main-box {
    background: #fff;
    .bottom {
      padding: 20px 0 40px 0;
      text-align: center;
    }
    border-radius: 0px 0px 10px 10px;
  }

  .simplebarWrapLeft {
    width: 242px;
    /deep/.simplebar-scrollbar:before {
      background: #0e756a;
    }
  }
  .frame {
    border: none;
    width: 100%;
    height: 100%;
  }
  .simplebarWrap {
    /deep/.simplebar-scrollbar:before {
      background: #0e756a;
    }
    /* 定制滚动条轨道 */
    .simplebar-track.simplebar-vertical {
      width: 10px; /* 设置宽度 */
    }

    /* 定制滚动条滑块 */
    .simplebar-scrollbar.simplebar-vertical .simplebar-thumb {
      width: 10px; /* 设置滑块宽度 */
      background-color: red; /* 设置滑块颜色 */
      border-radius: 10px; /* 设置滑块圆角 */
    }

    /* 定制滚动条轨道和滑块的交界处 */
    .simplebar-track.simplebar-vertical .simplebar-scrollbar {
      border-radius: 10px; /* 设置圆角 */
    }
  }
}
</style>
